import { useState, useMemo } from "react";
import { formatMomentDate } from "../../../utils/dateHelper";
import { PlusIcon } from "../../../assets/icons";
import CommonButton from "../../../components/commonButton";
import StatusChip from "../../../components/statusChip/StatusChip";
import ConfirmModal from "../../../components/withModal/ConfirmModal";
import { TableSearch } from "../../../components/form/Fields";
import CustomTable from "../../../components/table/CustomTable";
import { UserInital } from "../../../utils/otherHelopers";

const ListSection = ({
  data,
  isLoading,
  searchTerm,
  setSearchTerm,
  onAdd,
  onEdit,
  onDelete,
  pagination,
}) => {
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  const filteredData = data || [];

  const handleConfirmDeactivate = () => {
    if (selectedClient && typeof onDelete === "function") {
      onDelete(selectedClient.id);
      setShowStatusModal(false);
      setSelectedClient(null);
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "user",
        header: "USER",
        cell: (_, row) => (
          <div className="d-flex align-items-center gap-2">
            <UserInital
              name={`${row.user?.first_name || ""} ${row.user?.last_name || ""}`}
              image={row.user?.profile?.profile_photo?.url}
            />
            <div className="d-flex flex-column">
              <span className="fw-semibold">
                {row.user
                  ? `${row.user.first_name || ""} ${row.user.last_name || ""}`.trim()
                  : "-"}
              </span>
              <span className="text-muted small">
                {row.user?.mobile_number || "-"}
              </span>
            </div>
          </div>
        ),
      },
      {
        id: "name",
        header: "CLIENT NAME",
        cell: (_, row) => row.name,
      },
      {
        id: "mobile_number",
        header: "MOBILE NUMBER",
        cell: (_, row) => row.mobile_number || "-",
      },
      {
        id: "email",
        header: "EMAIL ADDRESS",
        cell: (_, row) => row.email || "-",
      },
      {
        id: "state",
        header: "STATE",
        cell: (_, row) => row.state?.name || "-",
      },
      {
        id: "city",
        header: "CITY",
        cell: (_, row) => row.city?.name || "-",
      },
      {
        id: "status",
        header: "STATUS",
        cell: (_, row) => (
          <StatusChip
            bg={row.is_active ? "success" : "danger"}
            pill
            title={row.is_active ? "Active" : "Inactive"}
            className={onDelete ? "cursor-pointer" : ""}
            onClick={() => {
              if (onDelete) {
                setSelectedClient(row);
                setShowStatusModal(true);
              }
            }}
          />
        ),
      },
      {
        id: "created_at",
        header: "CREATED AT",
        accessor: "created_at",
        cell: (v) =>
          v
            ? formatMomentDate(v, "DD-MM-YYYY hh:mm A")
            : "-",
      },
      {
        id: "updated_at",
        header: "UPDATED AT",
        accessor: "updated_at",
        cell: (v) => formatMomentDate(v, "DD-MM-YYYY hh:mm A"),
      },
    ],
    [onDelete],
  );

  const actionList = useMemo(
    () =>
      [
        onEdit && {
          title: "Edit",
          handler: (row) => onEdit(row),
        },
        onDelete && {
          title: (row) => (row.is_active ? "Deactivate" : "Activate"),
          handler: (row) => {
            setSelectedClient(row);
            setShowStatusModal(true);
          },
        },
      ].filter(Boolean),
    [onEdit, onDelete],
  );

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <TableSearch
          value={searchTerm}
          placeholder="Search by name, email, mobile"
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {onAdd && (
          <CommonButton
            variant="primary"
            icon={<PlusIcon />}
            title="Add Client"
            type="button"
            onClick={onAdd}
          />
        )}
      </div>

      <CustomTable
        data={filteredData}
        columns={columns}
        loading={isLoading}
        keyField="id"
        emptyMessage="No clients found"
        actionList={actionList}
        pagination={pagination}
      />

      <ConfirmModal
        isOpen={showStatusModal}
        onClose={() => {
          setShowStatusModal(false);
          setSelectedClient(null);
        }}
        title={
          selectedClient?.is_active ? "Deactivate Client" : "Activate Client"
        }
        message={`Are you sure you want to ${selectedClient?.is_active ? "deactivate" : "activate"} this client?`}
        onConfirm={handleConfirmDeactivate}
      />
    </>
  );
};

export default ListSection;
